module.exports = __webpack_public_path__ + "static/media/sy.93007050.svg";